import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CpTwobarschartComponent } from './cp-twobarschart.component';

@NgModule({
  declarations: [CpTwobarschartComponent],
  exports: [CpTwobarschartComponent],
  imports: [CommonModule]
})
export class TwoBarschartModule { }

